<script>

export default {
  name: "Modal-code-form",
  emits:[
    "add-item",
  ],
  data() {
    return {
      id      : "",
      code    : "",
      parentCode  : "",
      description : "",
      codeLabel   : "",
      value   : "",
      status  : 0
    }
  },
  methods : {
    addItem(){
      const newData = {
        code        : this.code,
        parentCode  : this.parentCode,
        description : this.description,
        codeLabel   : this.codeLabel,
        value       : this.value,
        status      : this.status,
      }
      this.$emit("add-item", newData)
      this.$emit("close-modal")
    },
    
      // 모달닫기
      closeModal() {
        this.$emit("close-modal")
      },
  }
}
</script>

<template>
  <q-card style="width: 700px; max-width: 80vw;">
    <q-card-section>
      <div class="row justify-between">
        <div class="text-h6">
          코드추가
        </div>
        <div>
          <q-btn
            @click="closeModal()" 
            flat v-close-popup round dense icon="close" />
        </div>
      </div>
      <div></div>
    </q-card-section>
    <q-card-section class="q-pt-none">
      <div class="row q-mb-sm q-gutter-sm">
        <div class="col">

          <q-input 
            v-model="code"
            :maxlength="6"
            label="코드" />    
        
        </div>

        <div class="col">

          <q-input 
            v-model="parentCode"
            :maxlength="6"
            label="부모코드" />

        </div>
      </div>
      <div class="row q-mb-sm q-gutter-sm">
        <div class="col">
        
          <q-input 
            v-model="codeLabel"
            :maxlength="100"
            label="코드라벨" />

        </div>
        <div class="col">

          <q-input 
            v-model="value"
            :maxlength="11"
            label="키값" />    

        </div>
      </div>
      <div class="row">
        <div class="col">

          <q-input 
            v-model="description"
            type="textarea"
            :maxlength="1000"
            label="설명" />    

        </div>
      </div>
    </q-card-section>
    <q-footer class="bg-white text-black">
      <q-toolbar>
        <q-btn
          label="추가"
          class="full-width"
          color="primary"
          @click="addItem">
        </q-btn>
      </q-toolbar>
    </q-footer>
  </q-card>
</template>
